/**
 * @name Gallery
 * @function
 * @description 갤러리
 */

import { useState } from "react";
import { ImgText } from "../components/ImgText";
import { Pagination } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { FaXmark } from "react-icons/fa6";

const products: any = [];

for (let i = 0; i <= 85; i++) {
  products.push({
    name: `${i}`,
    img: `http://choihyu.com/image/gallery/${i}.jpg`,
  });
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
};

export const Gallery = (): JSX.Element => {
  let num = 12;
  const [page, setPage] = useState<number>(1);
  const [open, setOpen] = useState<boolean>(false);
  const [link, setLink] = useState<string>("");

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  return (
    <div>
      <ImgText title="Gallery" text="갤러리" />

      <div className="flex flex-col items-center justify-center w-full p-2 sm:p-6">
        <div className="flex flex-wrap items-center justify-center pb-6 max-w-7xl">
          {products.map((item: any, index: number) => {
            return (
              <>
                {(page - 1) * num <= index &&
                  (page - 1) * num + num > index && (
                    <div className="p-1 sm:p-3 max-w-[8rem] sm:max-w-[20rem] cursor-pointer">
                      <img
                        src={item.img}
                        alt="Gallery"
                        onClick={() => {
                          setOpen(true);
                          setLink(item.img);
                        }}
                      />
                    </div>
                  )}
              </>
            );
          })}
        </div>
        <Modal
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style} className="w-[80%] sm:w-[60%]">
            <FaXmark
              size={24}
              className="absolute text-white cursor-pointer right-5 top-5"
              onClick={() => setOpen(false)}
            />

            <img src={link} alt="Gallery" className="w-full" />
          </Box>
        </Modal>
        <Pagination count={8} page={page} onChange={handleChange} />
      </div>
    </div>
  );
};
